import { Component, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'input-group-add-dropdown',
    templateUrl: './input-group-add-dropdown.component.html',
    standalone: false
})
export class InputGroupAddDropdownComponent {
	@Input() dropdownContent: TemplateRef<any>;
	@Input() disabled: boolean;
}
